import React, {CSSProperties, forwardRef } from "react";
import {Input, Button, message, Form} from "antd";
import {FormInstance} from "antd/lib/form/hooks/useForm";


// 字段名称枚举
enum FieldNameEnum {
    customExtendTitle = 'customExtendTitle',
    customExtendLink = 'customExtendLink',
}


interface ExtendArticleProps {
    className?: string;
    style?: CSSProperties;
    form: FormInstance;
    onChange?: (value: any) => void;
}


/**
 * 扩展阅读表单组件
 * @param props
 * @param ref
 * @constructor
 */
const ArticleExtInput = (props: ExtendArticleProps, ref: any) => {
    const { className, style, form, onChange = () => {} } = props;
    const { getFieldValue, getFieldsValue, resetFields } = form;


    /**
     * 添加
     */
    const add = () => {
        const values = getFieldsValue();
        let title = values[FieldNameEnum.customExtendTitle];
        let link = values[FieldNameEnum.customExtendLink];
        if (!title || (title && !title.trim())) {
            message.error('请输入标题');
            return;
        }
        if (!link || (link && !link.trim())) {
            message.error('请输入链接');
            return;
        }
        resetFields([FieldNameEnum.customExtendTitle, FieldNameEnum.customExtendLink]);
        onChange({title, link});
    }


    return (
        <div className={className} style={style}>
            <div className="flexic">
                <Form.Item name={FieldNameEnum.customExtendTitle} noStyle>
                    <Input
                        className="extend-read-form-input-title"
                        allowClear
                        placeholder="请输入标题"
                    />
                </Form.Item>
                <span className="dashes-line"></span>
                <Form.Item name={FieldNameEnum.customExtendLink} noStyle>
                    <Input
                        className="extend-read-form-input-link"
                        allowClear
                        placeholder="请输入链接"
                    />
                </Form.Item>
                <Form.Item shouldUpdate noStyle>
                    {() => (
                        <Button
                            className="confirm-add-btn"
                            type="primary"
                            disabled={!getFieldValue(FieldNameEnum.customExtendTitle) || !getFieldValue(FieldNameEnum.customExtendLink)}
                            onClick={add}
                        >确认添加
                        </Button>
                    )}
                </Form.Item>
            </div>
        </div>
    )
}


export default forwardRef(ArticleExtInput);
